import { tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  AnnuityGraphFI,
  EqualPaymentGraphFI,
  FixedAnnuityGraphFI,
  EqualPaymentGraphEN,
  AnnuityGraphEN,
  FixedAnnuityGraphEN,
} from '../../../images';

const graphImages = {
  en: {
    annuity: AnnuityGraphEN,
    fixedAnnuity: FixedAnnuityGraphEN,
    serial: EqualPaymentGraphEN,
  },
  fi: {
    annuity: AnnuityGraphFI,
    fixedAnnuity: FixedAnnuityGraphFI,
    serial: EqualPaymentGraphFI,
  },
} as const;

type Language = keyof typeof graphImages;
type Method = keyof typeof graphImages.en;

const methods = ['annuity', 'fixedAnnuity', 'serial'];

export const RefundMethodTooltip = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <TooltipWrapper>
      {methods.map((method) => (
        <div key={method}>
          <Typography.Body>{t(`form.repaymentMethod.options.${method}`)}</Typography.Body>
          <GraphImage
            src={graphImages[language as Language][method as Method]}
            alt={t(`form.repaymentMethod.options.${method}`)}
          />
          <Typography.Body size={'md'}>{t(`form.repaymentMethod.tooltip.${method}`)}</Typography.Body>
        </div>
      ))}
    </TooltipWrapper>
  );
};

const TooltipWrapper = styled.div`
  max-width: 780px;
  padding: ${tokens.size.spacingSm.value};
  gap: ${tokens.size.spacingSm.value};

  @media (min-width: 420px) {
    display: flex;
  }
`;

const GraphImage = styled.img`
  transform: scale(0.85);
  max-width: 240px;
  transform-origin: center;
  object-fit: contain;
  display: block;
`;
